import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import {
  CURRENCY_MASK_CONFIG,
  CurrencyMaskConfig,
  CurrencyMaskModule,
} from 'ng2-currency-mask';
import { NgxMaskModule } from 'ngx-mask';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { CrudMultiInputSelectComponent } from './crud-multi-input-select/crud-multi-input-select.component';
import { CrudSelectComponent } from './crud-select/crud-select.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { DatetimePickerComponent } from './datetime-picker/datetime-picker.component';
import { ImageButtonComponent } from './image-button/image-button.component';
import { ImageComponent } from './image/image.component';
import { InputColorComponent } from './input-color/input-color.component';
import { InputCurrencyComponent } from './input-currency/input-currency.component';
import { InputFileWithCommentComponent } from './input-file-with-comment/input-file-with-comment.component';
import { InputFileComponent } from './input-file/input-file.component';
import { InputNumberComponent } from './input-number/input-number.component';
import { InputPercentComponent } from './input-percent/input-percent.component';
import { InputTextAreaComponent } from './input-text-area/input-text-area.component';
import { InputTextComponent } from './input-text/input-text.component';
import { InputTimeComponent } from './input-time/input-time.component';
import { InputComponent } from './input/input.component';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { RangeDatePickerComponent } from './range-date-picker/range-date-picker.component';
import { SearchInputComponent } from './search-input/search-input.component';
import { SelectAutocompleteComponent } from './select-autocomplete/select-autocomplete.component';
import { SelectComponent } from './select/select.component';
import { SlideToggleComponent } from './slide-toggle/slide-toggle.component';
import { TimePickerComponent } from './time-picker/time-picker.component';
import { InputFileWithCommentCommentModule } from './input-file-with-comment/input-file-with-comment-comment/input-file-with-comment-comment.module';
import { InputFileWithCommentAndDateComponent } from './input-file-with-comment-and-date/input-file-with-comment-and-date.component';
import { InputCellPhoneAreaCodeComponent } from './input-cellphone-area-code/input-cellphone-area-code.component';
import { CheckboxGroupComponent } from './checkbox-group/checkbox-group.component';
import { RadioButtonGroupComponent } from './radio-button-group/radio-button-group.component';
import { SelectAdvancedSearchComponent } from './select-advanced-search/select-advanced-search.component';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.',
};

const fieldsModule = [
  CrudMultiInputSelectComponent,
  CrudSelectComponent,
  DatetimePickerComponent,
  DatePickerComponent,
  ImageComponent,
  ImageButtonComponent,
  InputComponent,
  InputColorComponent,
  InputCurrencyComponent,
  InputNumberComponent,
  InputPercentComponent,
  MultiSelectComponent,
  SearchInputComponent,
  SelectComponent,
  SelectAdvancedSearchComponent,
  RangeDatePickerComponent,
  SlideToggleComponent,
  TimePickerComponent,
  InputTimeComponent,
  InputTextComponent,
  InputFileComponent,
  InputFileWithCommentComponent,
  InputFileWithCommentAndDateComponent,
  InputCellPhoneAreaCodeComponent,
  InputTextAreaComponent,
  SelectAutocompleteComponent,
  CheckboxGroupComponent,
  RadioButtonGroupComponent,

];

@NgModule({
  declarations: [...fieldsModule, InputTimeComponent, RangeDatePickerComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMaskModule.forChild(),
    AngularMaterialModule,
    CurrencyMaskModule,
    FlexLayoutModule,
    InputFileWithCommentCommentModule
  ],
  exports: [...fieldsModule],
  providers: [
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'DD/MM/YYYY',
        },
        display: {
          dateInput: 'DD/MM/YYYY',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
  ],
})
export class FieldsModule { }
